<template>
    <div class="container">
        <content-header title="Подготовка к рентгенологическому исследованию млечных протоков"/>
        <p><strong>Подготовка к рентгенологическому исследованию млечных протоков (дуктографии или
            галактографии)</strong></p>
        <p>Консультация хирурга, цитологическое исследование выделений из сока (при выделениях их нескольких протоков,
            обязательная маркировка протоков), УЗИ молочных желез/маммография (в зависимости от возраста).</p>
        <p>За сутки до исследования пропить спазмолитики (но-шпа по 2 таблетки 3 раза в день), успокоительное на
            ночь!</p>
        <p>Дуктографию проводят на 5-12 день менструального цикла, когда железа максимально расслаблена и отсутствуют
            болезненные явления и уплотнения в молочной железе. Во время менопаузы дуктографию проводят в любой
            день.</p>
        <p>Перед проведением дуктографии женщине категорически запрещается надавливать на сосок для получения выделений,
            с целью предупреждения спазма млечных протоков.</p>
    </div>
</template>

<script>
import ContentHeader from "../../components/layout/ContentHeader";

export default {
    name: "Подготовка к рентгенологическому исследованию млечных протоков",
    components: {
        ContentHeader
    },
}

</script>

<style lang="scss" scoped>
.container {
    text-align: left;
    font-family: Arial, sans-serif;
    font-size: 13px;
}

strong {
    color: rgb(0, 0, 0);
    font-weight: 700;
    padding: 0;
}

p {
    padding: 1em 0;
    color: #666;
    line-height: 150%;
}

.bold {
    font-weight: bold;
}

.left-1em {
    margin-left: 1em;
}

h3 {
    font-size: 18px;
    margin: 0;
    padding: 0;
    font-weight: normal;
    color: #000;
}

h3:after {
    content: "";
    display: block;
    bottom: 0;
    width: 50px;
    height: 2px;
    background: #00b6cc;
    margin-top: 10px
}

.inv-divider {
    height: 32px;
    display: block;
    width: 100%;
}

.divider {
    height: 1px;
    border-top: 1px solid #ebebeb;
    display: block;
    position: relative;
    top: 1px;
    width: 100%;
    margin: 20px 0;
}

.flex {
    display: flex;
}

.flex.center {
    align-items: center;
}

.box {
    display: inline-block;
    text-align: center;
    width: 225px;
    margin-left: 30px;
}

.box:first-child {
    margin: 0;
}

.link {
    color: #006688;
    border-bottom: 1px dotted #006688;
    text-decoration: none;
    display: block;
    width: fit-content;
    height: fit-content;
}

.left-30px {
    margin-left: 30px;
}

hr {
    display: block;
    unicode-bidi: isolate;
    margin-block-start: 0.5em;
    margin-block-end: 0.5em;
    margin-inline-start: auto;
    margin-inline-end: auto;
    overflow: hidden;
    border-style: inset;
    border-width: 1px;
    color: #666;
    line-height: 1;
}

</style>
